
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 25","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19 21.5v.75-.75zm-14 0v.75-.75zm-2-.75a.75.75 0 000 1.5v-1.5zm6-14a.75.75 0 100 1.5v-1.5zm1 1.5a.75.75 0 000-1.5v1.5zm-1 2.5a.75.75 0 000 1.5v-1.5zm1 1.5a.75.75 0 000-1.5v1.5zm4-5.5a.75.75 0 000 1.5v-1.5zm1 1.5a.75.75 0 000-1.5v1.5zm-1 2.5a.75.75 0 000 1.5v-1.5zm1 1.5a.75.75 0 000-1.5v1.5zm6 10a.75.75 0 000-1.5v1.5zm-14-18h10v-1.5H7v1.5zM18.25 5.5v16h1.5v-16h-1.5zm-12.5 16v-16h-1.5v16h1.5zM17 4.25c.69 0 1.25.56 1.25 1.25h1.5A2.75 2.75 0 0017 2.75v1.5zM7 2.75A2.75 2.75 0 004.25 5.5h1.5c0-.69.56-1.25 1.25-1.25v-1.5zm-4 19.5h2v-1.5H3v1.5zm8-6h2v-1.5h-2v1.5zm-2-8h1v-1.5H9v1.5zm0 4h1v-1.5H9v1.5zm5-4h1v-1.5h-1v1.5zm0 4h1v-1.5h-1v1.5zm-1 4a.25.25 0 01.25.25h1.5A1.75 1.75 0 0013 14.75v1.5zm-2.25.25a.25.25 0 01.25-.25v-1.5a1.75 1.75 0 00-1.75 1.75h1.5zM10 20.75H5v1.5h5v-1.5zm-.75-4.25v5h1.5v-5h-1.5zM19 22.25h2v-1.5h-2v1.5zm0-1.5h-5v1.5h5v-1.5zm-5 0h-4v1.5h4v-1.5zm-.75-4.25v5h1.5v-5h-1.5z"}})])
          )
        }
      }
    